import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
	withStyles,
	Button,
	Dialog,
	AppBar,
	Toolbar,
	IconButton,
	Slide} from '@material-ui/core';
import {deletePaymentMethod, closeModalCB,	closeModal,	closeModalCB_2,closeModalCB_3,	closeModal_2} from "./../../actions/CustomerActions";

const styles = {
	appBar: {
		position: 'relative',
	},
	flex: {
		flex: 1,
	},
};

function Transition(props) {
	return <Slide direction="up" {...props} />;
}
class FullScreenDialog extends Component {

	state = {
    displayIngenico: false,
    redirectionUrl: '',
    isOpen : false,
    _isOpen : false
  };

	componentDidUpdate(nextProps, nextState, nextContext) {
		const {paymentMethod, status} = this.props;
		if (nextProps.ingenico != this.props.ingenico) {
			const {hostedCheckoutUrl} = this.props.ingenico;
			!!hostedCheckoutUrl && status === "SUCCESS" &&  this.props.dispatch(deletePaymentMethod(paymentMethod.id))
      !!hostedCheckoutUrl && status === "SUCCESS" && this.handleUrl(hostedCheckoutUrl);
			return false;
		}
		return true;
	}
	handleIngenico = () => {
		this.setState({displayIngenico: !this.state.displayIngenico})
	};

	closeIngenico = ()=>{
    this.props.dispatch(closeModal());
    this.props.dispatch(closeModalCB_2());
    this.props.dispatch(closeModalCB_3());
	}

	handleUrl = value => this.setState({redirectionUrl: value}, () => this.handleIngenico());

	render() {
		const {classes} = this.props;
		return (
			<div>
				<Dialog maxWidth="md"
						open={this.state.displayIngenico}
						onClose={this.closeIngenico}
						TransitionComponent={Transition}>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<Button color="inherit" onClick={this.closeIngenico}>
								Close
							</Button>
						</Toolbar>
					</AppBar>
					<iframe className="iframe-ingenico" style={{width: "500px", height: "500px"}} id="iFrame" src={this.state.redirectionUrl}>
						Iframe is not supported by your browser.
					</iframe>
				</Dialog>
			</div>
		);
	}
}

FullScreenDialog.propTypes = {
	classes: PropTypes.object.isRequired,
	src: PropTypes.string
};

export default withStyles(styles)(FullScreenDialog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/FullScreenDialog.jsx